import React, { useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";
import { get } from "../../helpers/api_helper";

//i18n
import { withTranslation } from "react-i18next";
import { color } from "echarts";
import { MODULES_LIST, SHOW_ROLE } from "helpers/api_endpoints";
import { useState } from "react";

const SidebarContent = props => {
	const [modules, setModules] = useState([]);
	const [role, setRole] = useState(null);
	const ref = useRef();
	const user = JSON.parse(localStorage.getItem('authUser')).user;
	const roles = user.Roles.map(el => el.id);
	const partnerUser = roles.includes(4);
	const adminUser = roles.includes(2);
	const superAdminUser = roles.includes(1);
	const driverUser = roles.includes(3);
	const navigate = useNavigate();


		useEffect(() => {
			get(MODULES_LIST).then(response => {
				setModules(response.data);
			}).catch(error => {
				if (error.response.status == 401) {
					navigate('/login');
				}})
		}, []);

		useEffect(() => {
      const roleId = Math.min(...roles);
			get(SHOW_ROLE + `/${roleId}`)
			.then(response => {
				const data = response.data;
				setRole(data);
			})
				.catch(error => {
					if (error.response.status == 401) {
						navigate('/login');
					}
				})
		}, [modules]);

		const activateParentDropdown = useCallback((item) => {
		item.classList?.add("active");
		const parent = item.parentElement;
		const parent2El = parent.childNodes[1];

		if (parent2El && parent2El.id !== "side-menu") {
			parent2El.classList.add("mm-show");
		}

		if (parent) {
			parent.classList.add("mm-active");
			const parent2 = parent.parentElement;

			if (parent2) {
				parent2.classList.add("mm-show"); // ul tag

				const parent3 = parent2.parentElement; // li tag

				if (parent3) {
					parent3.classList.add("mm-active"); // li
					parent3.childNodes[0].classList.add("mm-active"); //a
					const parent4 = parent3.parentElement; // ul
					if (parent4) {
						parent4.classList.add("mm-show"); // ul
						const parent5 = parent4.parentElement;
						if (parent5) {
							parent5.classList.add("mm-show"); // li
							parent5.childNodes[0].classList.add("mm-active"); // a tag
						}
					}
				}
			}
			scrollElement(item);
			return false;
		}
		scrollElement(item);
		return false;
	}, []);

	const removeActivation = (items) => {
		for (var i = 0; i < items.length; ++i) {
			var item = items[i];
			const parent = items[i].parentElement;

			if (item && item.classList.contains("active")) {
				item.classList.remove("active");
			}
			if (parent) {
				const parent2El =
					parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
						? parent.childNodes[1]
						: null;
				if (parent2El && parent2El.id !== "side-menu") {
					parent2El.classList.remove("mm-show");
				}

				parent.classList.remove("mm-active");
				const parent2 = parent.parentElement;

				if (parent2) {
					parent2.classList.remove("mm-show");

					const parent3 = parent2.parentElement;
					if (parent3) {
						parent3.classList.remove("mm-active"); // li
						parent3.childNodes[0].classList.remove("mm-active");

						const parent4 = parent3.parentElement; // ul
						if (parent4) {
							parent4.classList.remove("mm-show"); // ul
							const parent5 = parent4.parentElement;
							if (parent5) {
								parent5.classList.remove("mm-show"); // li
								parent5.childNodes[0].classList.remove("mm-active"); // a tag
							}
						}
					}
				}
			}
		}
	};

	const path = useLocation();
	const activeMenu = useCallback(() => {
		const pathName = path.pathname;
		let matchingMenuItem = null;
		const ul = document.getElementById("side-menu");
		const items = ul.getElementsByTagName("a");
		removeActivation(items);

		for (let i = 0; i < items.length; ++i) {
			if (pathName === items[i].pathname) {
				matchingMenuItem = items[i];
				break;
			}
		}
		if (matchingMenuItem) {
			activateParentDropdown(matchingMenuItem);
		}
	}, [path.pathname, activateParentDropdown]);

	useEffect(() => {
		ref.current.recalculate();
	}, []);

	useEffect(() => {
    setTimeout(() => {
		new MetisMenu("#side-menu");
		activeMenu();
    }, 1500);
	}, []);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		activeMenu();
	}, [activeMenu]);

	function scrollElement(item) {
		if (item) {
			const currentPosition = item.offsetTop;
			if (currentPosition > window.innerHeight) {
				ref.current.getScrollElement().scrollTop = currentPosition - 300;
			}
		}
	}

  const getModules = () => {
		return modules && modules.length > 0 && (
									<ul style={{ display: "block" }}>
										<li className="menu-title">{props.t("Menu")} </li>
										{modules.map((module, index) => (role?.RolePermissions.filter(el => el.Screen.moduleId == module.id).length > 0 || superAdminUser) && (
											<li key={index} >
												<Link to='/#' className="has-arrow">
													<i className="bx bx-globe"></i>
													<span>{props.t(module.title)}</span>
												</Link>
												{getScreens(module)}
											</li>
										))}
									</ul>
								)
	}

  const getScreens = (module) => {
		return module.screen && module.screen.length > 0 && role?.RolePermissions.filter(el => el.PermissionId == 1 && el.Screen.moduleId == module.id).length > 0 ?(<ul className="sub-menu">
		{ 
				module.screen.map((screen, i) =>{
			const perm = role?.RolePermissions.find(el => el.ScreenId == screen.id && el.PermissionId == 1)??null;
			// console.log('screen', screen.id, perm, role?.RolePermissions);
			return perm && (
						<li key={i}>
							<Link to={`${screen.path}`}>
								{props.t(screen.title)}
							</Link>
						</li>

			)
		} 
		)}
		</ul>):null;
	}

	return (
		<React.Fragment>
			<SimpleBar className="h-100" ref={ref}>
				<div id="sidebar-menu">
					<div className="metismenu list-unstyled" id="side-menu">
						<h4 className="m-3">
							Welcome{" "}
							<span style={{ color: "orange" }}>
								{user.partner ? user.partner?.name : user.name}
							</span>
						</h4>
						{getModules()}

						<ul style={{ display: "block" }}>
							<li>
								<Link to="/logout">
									<i className="dripicons-power" />
									<span>{props.t("Logout")}</span>
								</Link>
							</li>
						</ul> 
					</div>
				</div>
			</SimpleBar>
		</React.Fragment>
		)
};

SidebarContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
